/**
 * Before NEW_INCIDENT, upload encrypted context to the feeds bucket and add contextS3Key.
 * Does not block creating the incident if upload fails.
 */

import {
  appendContextS3KeyToUrl,
  isNewIncidentRequest,
  loadIncidentContextFromFeedsBucket,
  uploadIncidentContextToFeedsBucket,
  urlAlreadyHasContextKey,
} from './incident-context-feeds-upload.js';

const PATCH_FLAG = '__trazitIncidentContextS3HookInstalled';

export function installIncidentContextS3UploadHook() {
  if (typeof window === 'undefined') return;
  if (window[PATCH_FLAG]) return;
  window[PATCH_FLAG] = true;

  window.trazitUploadIncidentContextToFeedsBucket = uploadIncidentContextToFeedsBucket;
  window.trazitLoadIncidentContextFromFeedsBucket = loadIncidentContextFromFeedsBucket;

  const orig = window.fetch.bind(window);
  window.fetch = async function patchedFetchForIncidentContextS3(input, init) {
    let nextInput = input;
    const urlStr =
      typeof input === 'string'
        ? input
        : input && typeof input.url === 'string'
          ? input.url
          : '';

    if (isNewIncidentRequest(urlStr) && !urlAlreadyHasContextKey(urlStr)) {
      try {
        const uploaded = await uploadIncidentContextToFeedsBucket();
        if (uploaded?.contextS3Key) {
          const nextUrl = appendContextS3KeyToUrl(urlStr, uploaded.contextS3Key);
          if (typeof input === 'string') {
            nextInput = nextUrl;
          } else if (input instanceof Request) {
            nextInput = new Request(nextUrl, input);
          } else {
            nextInput = nextUrl;
          }
        }
      } catch (err) {
        console.warn('[TRAZiT incident-context] S3 upload failed; NEW_INCIDENT continues', err);
      }
    }

    return orig(nextInput, init);
  };
}
